import React, { Component } from 'react'

export default class HelpPage extends Component {
    render() {
        return (
            <div>
                <h2>暂无资料</h2>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/containers/HelpPage/HelpPage.jsx